import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { storageApi } from '../utils/api';
import { StorageData } from '../types/storage';
import { format } from 'date-fns';
import PrintLabel from './PrintLabel';
import { formatPlateForDisplay } from '../utils/plateFormatter';

interface Props {
  id?: string;
  onClose: () => void;
  onEdit: (id: string) => void;
}

const StorageDetail: React.FC<Props> = ({ id, onClose, onEdit }) => {
  const { id: urlId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [storage, setStorage] = useState<StorageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    const loadStorage = async () => {
      try {
        if (!id) return;
        const response = await storageApi.getById(id);
        if (response.data?.data) {
          setStorage(response.data.data);
        }
      } catch (err) {
        setError('Kayıt yüklenirken bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    loadStorage();
  }, [id]);

  if (loading) return <div className="loading">Yükleniyor...</div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!storage) return <div>Kayıt bulunamadı</div>;

  return (
    <div className="storage-detail">
      {isPrinting && storage && (
        <div style={{ display: 'none' }}>
          <PrintLabel 
            data={storage} 
            onPrintComplete={() => setIsPrinting(false)} 
          />
        </div>
      )}

      <h2>Lastik Detayı</h2>
      <div className="card">
        <div className="card-body">
          <div className="detail-row">
            <label>Müşteri:</label>
            <span>{storage.musteri}</span>
          </div>
          <div className="detail-row">
            <label>Depo:</label>
            <span>{storage.depo || '-'}</span>
          </div>
          <div className="detail-row">
            <label>No:</label>
            <span>{storage.no.toString().padStart(6, '0')}</span>
          </div>
          <div className="detail-row">
            <label>Tarih:</label>
            <span>{format(new Date(storage.tarih), 'dd.MM.yyyy')}</span>
          </div>
          <div className="detail-row">
            <label>Ebat:</label>
            <span>{storage.ebat}</span>
          </div>
          <div className="detail-row">
            <label>Marka:</label>
            <span>{storage.marka}</span>
          </div>
          <div className="detail-row">
            <label>Adet:</label>
            <span>{storage.adet}</span>
          </div>
          <div className="detail-row">
            <label>Araç:</label>
            <span>{storage.arac}</span>
          </div>
          <div className="detail-row">
            <label>Plaka:</label>
            <span>{formatPlateForDisplay(storage.plaka)}</span>
          </div>
          <div className="detail-row">
            <label>Telefon:</label>
            <span>{storage.telefon}</span>
          </div>
          <div className="detail-row">
            <label>Not:</label>
            <span>{storage.not || '-'}</span>
          </div>
        </div>
      </div>
      <div className="actions">
        <button 
          className="btn btn-primary me-2" 
          onClick={() => onEdit(id!)}
        >
          Düzenle
        </button>
        <button 
          className="btn btn-success me-2" 
          onClick={() => setIsPrinting(true)}
        >
          Yazdır
        </button>
        <button 
          className="btn btn-secondary" 
          onClick={onClose}
        >
          Geri Dön
        </button>
      </div>
    </div>
  );
};

export default StorageDetail; 